import { supabase } from './supabase'

export async function reviewApi(workshopId, operation, fields = {}) {
  const { data: session } = await supabase.auth.getSession()
  if (!session?.session?.access_token) throw new Error('Sign in to manage review invitations.')
  const response = await fetch('/.netlify/functions/review-settings', { method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${session.session.access_token}` },
    body: JSON.stringify({ workshop_id: workshopId, operation, ...fields }) })
  const result = await response.json()
  if (!response.ok || !result.data) throw new Error(result.error || 'Review invitations are unavailable.')
  return result.data
}
